export default "__VITE_ASSET__DEqlLmlo__"